export enum COMPANY_STATUES  {
  COMPANY_DETAILS = "COMPANY_DETAILS",
  FACILITY_TYPES = "FACILITY_TYPES",
  FACILITY_INFORMATION = "FACILITY_INFORMATION",
  EMISSION_SOURCE_SELECTION = "EMISSION_SOURCE_SELECTION",
  COMPLETE = "COMPLETE"
}

export interface Unit {
  id:string;
  name:string;
  label:string;
  unitCode: string;
  unitName: string;
}

export interface ExternalIDP {
  id: string;
  domain: string;
}

export interface Company {
  id: string;
  companyName: string;
  facilityLimit: number;
  userLimit: number;
  accountTypeName: string;
  scope3Onboarding: boolean;
  onboardingStatus: string;
  subSector: SubSector;
  idpDomain?: boolean;
  intensityUnit?: Unit;
}

export interface CompanyFacilityTypes {
  id?: string;
  logicalCompanyId?: string;
  facilityType: string;
  typeName: string;
  typeNameLabel?: string;
  facilityCount: number;
  typeOrder: number;
  isError?: boolean;
}

export interface SubSector {
  id: string;
  sector: Sector;
  subSectorName: string;
}

export interface Sector {
  id: string;
  sectorName: string;
}

export interface OperationYear {
  id?: string;
  year: string;
  globalWarmingPotential?: object;
  isBaseYear?: boolean;
  locked?: boolean;
}

export interface MetaDataKey {
  metaDataKey: string
}